export default class subscriberBlockStatistics {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/statistic/partials/subscriber-block-statistics.html'),
            scope: {
                collections: '='
            },
            controller: ['$scope', '$element', '$attrs', '$stateParams', '$rootScope', 'Statistics', (scope, element, attr, $stateParams, $rootScope, Statistics) => {

                Statistics.getCollectionUsageByCampaign($stateParams.id).then((collections) => {
                    scope.collections = collections;

                    angular.forEach(scope.collections, (collection) => {
                        collection.active = true;
                    });
                });

                scope.toggleCollectionActive = (collection) => {
                    collection.active = ! collection.active;

                    let collectionsToUse = [];

                    angular.forEach(scope.collections, (collection) => {
                        if (collection.active) {
                            collectionsToUse.push({ id: collection.id, type: collection.subscriber_collection_type_id });
                        }
                    });

                    // Kanske någon check ifall alla är aktiva att man skicka med null då istället??

                    $rootScope.$emit('statistics:updateWithCollections', collectionsToUse);
                };

                scope.isActive = (collection) => {
                    return collection.active;
                }
            }]
        }
    }
}
